module.exports = __webpack_public_path__ + "static/media/arrow-outputs.9e996a80.svg";